import React, { Component } from "react";
import './waves.css';

class Waves extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { waveProps } = this.props;
    return (
      <div className="rdp-component-audiobook-wave-container">
        <div style={{ display: 'flex', gap: '5px' }}>
          <div className="rdp-component-audiobook-bar" style={{ backgroundColor: 'black', animationDelay: '0.1s' }}></div>
          <div className="rdp-component-audiobook-bar" style={{ backgroundColor: 'black', animationDelay: '0.2s' }}></div>
          <div className="rdp-component-audiobook-bar" style={{ backgroundColor: 'black', animationDelay: '0.3s' }}></div>
          <div className="rdp-component-audiobook-bar" style={{ backgroundColor: 'black', animationDelay: '0.4s' }}></div>
          <div className="rdp-component-audiobook-bar" style={{ backgroundColor: 'black', animationDelay: '0.5s' }}></div>
        </div>
      </div>
    );
  }
}

export default Waves;